var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanelCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 19,
    viewBox: "0 0 29 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6364 0H1.63636C1.20237 0 0.786157 0.172402 0.47928 0.47928C0.172402 0.786157 0 1.20237 0 1.63636V17.3636C0 17.7976 0.172402 18.2138 0.47928 18.5207C0.786157 18.8276 1.20237 19 1.63636 19H26.6364C27.0704 19 27.4866 18.8276 27.7935 18.5207C28.1003 18.2138 28.2727 17.7976 28.2727 17.3636V1.63636C28.2727 1.20237 28.1003 0.786157 27.7935 0.47928C27.4866 0.172402 27.0704 0 26.6364 0ZM1.63636 1.63636H0.727273V17.3636H1.63636V1.63636ZM26.6364 17.3636H8.36364V1.63636H26.6364V17.3636Z",
    fill: "#F8F9FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9585 5.63998C16.8325 5.64009 16.7117 5.6897 16.6226 5.77866L13.2378 9.16342C13.1937 9.20758 13.1582 9.26004 13.1343 9.31772C13.1104 9.37545 13.0981 9.43785 13.0981 9.50034C13.0982 9.56262 13.1105 9.62441 13.1343 9.68198C13.1582 9.7396 13.1937 9.79214 13.2378 9.83627L16.6226 13.221C16.7117 13.3101 16.8325 13.3606 16.9585 13.3607C17.0847 13.3607 17.2061 13.3102 17.2954 13.221C17.3847 13.1317 17.4351 13.0104 17.4351 12.8841C17.4351 12.7578 17.3847 12.6365 17.2954 12.5472L14.7241 9.97592H21.8472C21.9734 9.97591 22.0948 9.92553 22.1841 9.83627C22.2731 9.74712 22.3227 9.6263 22.3228 9.50034C22.3228 9.37418 22.2732 9.25267 22.1841 9.16342C22.0948 9.07416 21.9734 9.02378 21.8472 9.02377H14.7241L17.2954 6.45248C17.3847 6.36317 17.4351 6.24187 17.4351 6.11557C17.435 5.98936 17.3847 5.86791 17.2954 5.77866C17.2061 5.68955 17.0846 5.63998 16.9585 5.63998Z",
    fill: "#F8F9FA",
    stroke: "#F8F9FA",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelCollapse);
export default __webpack_public_path__ + "static/media/panel-collapse.43127d5c826087d072975ec6de7caf6d.svg";
export { ForwardRef as ReactComponent };